module.exports = __webpack_public_path__ + "img/el_menu4.58628d47.png";